import SimpleDialog from "@rio-cloud/rio-uikit/SimpleDialog";

import { Scheduling } from "../../../../../../../models/schedule";

import "../styles.css";
import { getAssetRioPlan } from "../../../../../../../services/assetService";
import VehicleIcon from "../../../../../../../components/VehicleIcon";

interface ISchedulingDetailDialogProps {
  show: boolean;
  onClose: () => void;
  unviwedSchedulings: Scheduling[];
}

const UnviwedSchedulingsDialog = ({
  show,
  onClose,
  unviwedSchedulings,
}: ISchedulingDetailDialogProps) => {
  const { plans } = getAssetRioPlan(unviwedSchedulings[0]?.asset?.id ?? '');

  const dialogContent = (
    <>
      {unviwedSchedulings.length > 0 &&
        unviwedSchedulings.map((item) => (
          <div className="padding-25">
            <div className="text-size-20 text-bold padding-bottom-25 text-color-gray">
              {item.scheduleNumber}
            </div>

            <div className="row">
              <div className="col-4">
                <label className="block text-color-black text-size-20 text-bold margin-bottom-10">
                  Motorista
                </label>
                <div className="mt-1 p-2 border schedule-data__info">
                  <div className="truncate">
                    {item?.driver?.name ?? '-'}
                  </div>
                </div>
              </div>
              <div className="col-2">
                <label className="block text-color-black text-size-20 text-bold margin-bottom-10">
                  CNH
                </label>
                <div className="mt-1 p-2 border schedule-data__info">
                  <div className="truncate">
                    {item?.driver?.license ?? '-'}
                  </div>
                </div>
              </div>
              <div className="col-3">
                <label className="block text-color-black text-size-20 text-bold margin-bottom-10">
                  Telefone
                </label>
                <div className="mt-1 p-2 border schedule-data__info">
                  <div className="truncate">
                    {item?.driver?.phone ?? '-'}
                  </div>
                </div>
              </div>
              <div className="col-3">
                <label className="block text-color-black text-size-20 text-bold margin-bottom-10">
                  E-mail
                </label>
                <div className="mt-1 p-2 border schedule-data__info">
                  <div className="truncate">
                    {item?.driver?.email ?? '-'}
                  </div>
                </div>
              </div>
            </div>

                  <div className="padding-20 bg-lighter margin-y-20 vehicle-detais">
                    <div className="flex items-start gap-4">
                      <VehicleIcon 
                        chassis={item?.asset?.chassis} 
                        size={80}
                      />

                      <div className="flex-1 padding-left-10">
                  <p className="text-color-black text-size-16 font-medium m-0">
                    {item?.asset?.name} | Placa: {item?.asset?.licensePlate}
                  </p>
                  <p className="text-color-status-resting text-size-14 m-0">
                    Chassi - {item?.asset?.chassis}
                    <br />
                    Odômetro: {item?.asset?.odometer} km | Horímetro:{" "}
                    {item?.asset?.hourmeter} h
                  </p>
                </div>

                <div className="flex gap-6 margin-bottom-20">
                  {item?.asset?.tags?.map((tag, index) => (
                    <span key={index} className="px-2 py-1 green-tag">
                      {tag}
                    </span>
                  ))}
                  {/* <span className="px-2 py-1 green-tag">RIO</span>
                        <span className="px-2 py-1 green-tag">Em Garantia</span>
                        <span className="px-2 py-1 bg-white white-tag">Volkstotal Prev</span> */}
                </div>
              </div>

              <div className="padding-10">
                <div className="car-workshop">
                  <ul className="flex flex-column gap-15 m-0">
                    {
                      (item?.campaigns ?? []).length ?
                        <li className="flex justify-between">
                          <div className="text-color-black">Campanhas de campo</div>
                          <div className="text-bold">{item?.asset?.id ? plans : 'Grátis'}</div>
                        </li> : null
                    }

                    <li className="flex justify-between">
                      <div className="text-color-black">
                        {item?.checkup?.description}
                      </div>
                      <div className="text-bold">{item?.asset?.id ? plans : 'Grátis'}</div>
                    </li>

                    <li className="flex justify-between">
                      <div className="text-color-black">Total em serviços</div>
                      <div className="text-color-black">{item?.totalPrice}</div>
                    </li>
                    <li className="flex justify-between border-top-only border-width-1">
                      <div className="text-color-black text-bold">Total</div>
                      <div className="text-color-black text-bold">
                        {item?.totalPrice}
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div>
              <div className="text-size-14 text-medium">Importante!</div>
              <div className="text-size-14">{item?.observation}</div>
            </div>

            <div className="revision-itens margin-y-20">
              <h5 className="text-size-20 text-bold margin-bottom-10">
                Itens cobertos na revisão
              </h5>
              <div className="p-4 bg-white border">
                <div className="space-y-5 text-size-14 text-color-black m-0 padding-left-10">
                  {(item?.checkup?.parts ?? []).length === 0 && <p>-</p>}
                  {(item?.checkup?.parts ?? []).map((part, index) => (
                    <div key={index} className="padding-bottom-10 flex justify-between">
                      <p className="m-0">
                        {part.description}
                        {part.qtd ? ` (${part.qtd})` : ""}
                      </p>
                      {!part.isCovered && part.notCoveredReason && (
                        <p className="m-0 text-color-status-resting">{part.notCoveredReason}</p>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            </div>

            <div className="revision-itens">
              <h5 className="text-size-20 text-bold margin-bottom-0">
                Descrição dos Serviços Contratados
              </h5> 
              <div className="text-size-14 margin-bottom-10">
                Espaço para descrever informações importantes sobre "Serviços
                Contratados", adicionados no agendamento.
              </div>
              <div className="p-4 bg-white border">
                {item?.otherServices?.map((item, index) => (
                  <div key={index}>
                    <p>{item}</p>
                  </div>
                ))}
                {(item?.otherServices ?? []).length === 0 && <p>-</p>}
              </div>
            </div>

            <div className="revision-itens observation">
              <h5 className="text-size-20 text-bold margin-bottom-0">
                Observações
              </h5>
              <div className="text-size-14 margin-bottom-10">
                Espaço para relatar problemas na manutenção do seu veículo.
              </div>
              <div className="p-4 bg-white border">
                <ul className="space-y-5 text-size-14 text-color-black m-0 padding-left-10">
                  <li className="flex justify-between">
                    <span>{item?.observation || '-'}</span>
                  </li>
                </ul>
              </div>
            </div>

            <div className="revision-itens flex justify-between gap-6">
              <div className="w-1/3">
                <h5 className="text-size-20 text-bold margin-bottom-10">
                  Concessionária
                </h5>
                <div className="p-4 bg-white border card">
                  <p className="m-0 text-size-h5">{item?.dealership?.name}</p>
                  <p className="m-0">{item?.dealership?.address}</p>
                </div>
              </div>

              <div className="w-1/3">
                <h5 className="text-size-20 text-bold margin-bottom-10">
                  Data e horário:
                </h5>
                <div className="p-4 bg-white border card">
                  <p className="m-0 text-size-h5">
                    {item?.date.toLocaleDateString("pt-BR", {
                      day: "2-digit",
                      month: "long",
                      year: "numeric",
                    })}
                  </p>
                  <p className="m-0">
                    {item?.date.toLocaleTimeString([], {
                      hour: "2-digit",
                      minute: "2-digit",
                    })}
                  </p>
                </div>
              </div>

              <div className="w-1/3">
                <h5 className="text-size-20 text-bold margin-bottom-10">
                  Consultor:
                </h5>
                <div className="p-4 bg-white border card">
                  <p className="m-0 text-size-h5 text-capitalize">
                    {item?.consultant}
                  </p>
                </div>
              </div>
            </div>
          </div>
        ))}
    </>
  );

  const dialogFooter = (
    <div className="display-flex justify-content-center">
      <button
        type="button"
        className="btn btn-primary width-250"
        onClick={onClose}
      >
        Fechar
      </button>
    </div>
  );

  return (
    <SimpleDialog
      show={show}
      title="Detalhes do agendamento"
      subtitle="Confira abaixo as informações do agendamento"
      content={dialogContent}
      footer={dialogFooter}
      bsSize="lg"
      onClose={onClose}
      useOverflow
    />
  );
};

export default UnviwedSchedulingsDialog;
